import React, { useEffect, useState } from "react";
import {
    Box,
    Button,
    Grid,
    IconButton,
    TextField,
    Typography,
} from "@mui/material";
import SearchableDropdown from "../../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx";
import DynamicBreadcrumbs from "../../Shared/Breadcrumb/index.tsx";
import HomeIcon from '@mui/icons-material/Home';
import { useNavigate, useParams } from 'react-router-dom';
import { DecisionBoardActions } from "../../../Services/_actions/index.js";
import OrganisationDropdown from "../../Shared/OrganisationDropdown/index.tsx";

const EditCampaignDecisionBoard: React.FC = () => {
    const { proposalId } = useParams();
    const navigate = useNavigate();
    const action = DecisionBoardActions();
    const [endCustomerOptions, setEndCustomerOptions] = useState([]);
    const [formData, setFormData] = useState({
        proposal: {
            name: '',
            invoice_number: '',
            type_of_end_customer_name: '',
            tentative_start_date: '',
            tentative_end_date: '',
        },
        organisation: {
            label: '',
            value: ''
        }
    });

    console.log("tentative_start_date", formData.proposal.tentative_start_date);
    console.log("tentative_end_date", formData.proposal.tentative_end_date);

    const fetchProposalData = async () => {
        console.log(proposalId)
        if (proposalId) {
            const res = await action.getProposalData(proposalId);
            if (res?.status === 200 && res?.data) {
                const data = res.data;
                console.log("Fetched Proposal Data:", data);
                setFormData({
                    proposal: {
                        account: data.account || '',
                        brand: data.brand || '',
                        campaign_state: data.campaign_state || '',
                        cost_of_lead: data.cost_of_lead || '',
                        created_at: data.created_at || '',
                        created_by: data.created_by || '',
                        created_on: data.created_on || '',
                        endDate: data.tentative_start_date,
                        invoice_number: data.invoice_number || '',
                        is_disabled: data.is_disabled || '',
                        is_mix: data.is_mix || '',
                        name: data.name || '',
                        parent: data.parent || '',
                        payment_status: data.payment_status || '',
                        principal_vendor: data.principal_vendor || '',
                        proposal_id: data.proposal_id || '',
                        startDate: data.tentative_start_date,
                        status: data.status || '',
                        tentative_cost: data.tentative_cost || '',
                        // tentative_end_date: data.tentative_end_date || '',
                        // tentative_start_date: data.tentative_start_date || '',
                        tentative_start_date: data.tentative_start_date ? data.tentative_start_date.split('T')[0] : '',
                        tentative_end_date: data.tentative_end_date ? data.tentative_end_date.split('T')[0] : '',

                        type_of_end_customer: data.type_of_end_customer || '',

                        type_of_end_customer_formatted_name: data.type_of_end_customer_formatted_name || '',
                        type_of_end_customer_name: data.type_of_end_customer_name || '',

                        updated_at: data.updated_at || '',
                        updated_by: data.updated_by || '',
                        updated_on: data.updated_on || '',
                        user: data.user || '',


                        // name: data.name || '',
                        // invoice_number: data.invoice_number || '',
                        // type_of_end_customer_name: data.type_of_end_customer_name || '',
                        // tentative_start_date: data.tentative_start_date?.split('T')[0] || '',
                        // tentative_end_date: data.tentative_end_date?.split('T')[0] || '',
                    },
                    organisation: {
                        name: data.principal_vendor || ''
                    }
                });
            }
            else {
                console.error("Failed to fetch proposal data", res);
            }
        }
    };

    const fetchEndCustomer = async () => {
        try {
            const res = await action.getTypeOFEndCustomer(proposalId);
            if (res?.status === 200 && res?.data) {
                const mappedOptions = res.data.map(item => ({
                    label: item.name,
                    value: item.name
                }));
                console.log("End Customer Options:", mappedOptions);

                setEndCustomerOptions(mappedOptions);
            } else {
                console.error("Failed to fetch end customer options", res);
            }
        } catch (error) {
            console.error("Error fetching end customers", error);
        }
    };

    const convertToISOString = (dateStr: string): string | undefined => {
        if (!dateStr) return undefined;
        const date = new Date(dateStr);
        return date.toISOString(); // e.g., "2025-05-01T00:00:00.000Z"
    };


    const updateData = async () => {
        try {
            const proposal = formData.proposal;
            const payload = {
                proposal_id: proposal.proposal_id || proposalId,
                name: proposal.name,
                invoice_number: proposal.invoice_number,
                type_of_end_customer_name: proposal.type_of_end_customer_name,
                tentative_start_date: convertToISOString(proposal.tentative_start_date),
                tentative_end_date: convertToISOString(proposal.tentative_end_date),
                principal_vendor: formData.organisation?.value,

                // Optional fields (filtered below)
                account: proposal.account,
                brand: proposal.brand,
                campaign_state: proposal.campaign_state,
                cost_of_lead: proposal.cost_of_lead,
                created_at: proposal.created_at,
                created_by: proposal.created_by,
                created_on: proposal.created_on,
                endDate: convertToISOString(proposal.tentative_end_date),
                is_disabled: proposal.is_disabled,
                is_mix: proposal.is_mix,
                parent: proposal.parent,
                payment_status: proposal.payment_status,
                startDate: convertToISOString(proposal.tentative_start_date),
                status: proposal.status,
                tentative_cost: proposal.tentative_cost,
                type_of_end_customer: proposal.type_of_end_customer,
                type_of_end_customer_formatted_name: proposal.type_of_end_customer_formatted_name,
                updated_at: proposal.updated_at,
                updated_by: proposal.updated_by,
                updated_on: proposal.updated_on,
                user: proposal.user,
            };

            const cleanedPayload = Object.fromEntries(
                Object.entries(payload).filter(([_, v]) => v !== "" && v !== undefined && v !== null)
            );
            const res = await action.updateCampaignDesicionBoard(proposalId, cleanedPayload);
            if (res?.status === 200) {
                console.log("Update successful:", res.data);
                navigate(-1); // go back
            } else {
                console.error("Update failed", res);
            }
        } catch (error) {
            console.error("Error updating proposal:", error);
        }
    };

    const handleSubmit = () => {
        updateData();
    };

    useEffect(() => {
        fetchProposalData();
        fetchEndCustomer();
    }, [proposalId]);

    const handleInputChange = (field: string, value: string, nested = false) => {
        if (nested) {
            setFormData(prev => ({
                ...prev,
                proposal: {
                    ...prev.proposal,
                    [field]: value,
                },
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                [field]: value,
            }));
        }
    };

    const handleDropdownChange = (field: string, value: any) => {
        setFormData(prev => ({
            ...prev,
            proposal: {
                ...prev.proposal,
                [field]: value,
            },
        }));
    };

    const breadcrumbsData = [
        {
            label: <IconButton color="primary"><HomeIcon /></IconButton>,
            onClick: () => navigate('/')
        },
        { label: 'Edit Proposal Details' }
    ];

    return (
        <Box
            sx={{
                padding: "20px",
                maxWidth: "900px",
                margin: "auto",
                backgroundColor: "#f9f9f9",
                borderRadius: "8px",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            }}
        >
            <DynamicBreadcrumbs
                items={breadcrumbsData}
                onBreadcrumbClick={(e, item) => item?.onClick?.()}
            />
            <Typography variant="h5" sx={{ mb: 3, textAlign: "center", fontWeight: "bold" }}>
                Edit Proposal
            </Typography>

            <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label="Proposal Name"
                        placeholder="Enter Proposal Name"
                        variant="outlined"
                        size="small"
                        value={formData.proposal.name}
                        onChange={(e) => handleInputChange("name", e.target.value, true)}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label="Invoice Number"
                        placeholder="Enter Invoice Number"
                        variant="outlined"
                        size="small"
                        value={formData.proposal.invoice_number}
                        onChange={(e) => handleInputChange("invoice_number", e.target.value, true)}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label="Start Date"
                        type="date"
                        size="small"
                        value={formData.proposal.tentative_start_date}
                        onChange={(e) => handleInputChange("tentative_start_date", e.target.value, true)}
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label="End Date"
                        type="date"
                        size="small"
                        value={formData.proposal.tentative_end_date}
                        onChange={(e) => handleInputChange("tentative_end_date", e.target.value, true)}
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <OrganisationDropdown
                        sx={
                            { mt: '1px' }
                        }
                        value={formData.organisation}
                        onChange={(val) =>
                            setFormData(prev => ({
                                ...prev,
                                organisation: val
                            }))
                        }
                        label="Principal Vendor"
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <SearchableDropdown
                        label="Type of End Customer"
                        options={endCustomerOptions}
                        labelKey="label"
                        valueKey="value"
                        value={endCustomerOptions.find(option => option.value === formData.proposal.type_of_end_customer_name) || null}
                        onChange={(val) => {
                            console.log("Selected End Customer:", val);
                            handleDropdownChange("type_of_end_customer_name", val.value);
                        }}

                    />

                </Grid>
            </Grid>
            <Box mt={3} display="flex" justifyContent="flex-end" gap={2}>
                <Button variant="outlined" size="small" onClick={() => navigate(-1)}>
                    Cancel
                </Button>
                <Button
                    variant="contained"
                    onClick={handleSubmit}
                    color="primary"
                    size="small"
                >
                    Update
                </Button>
            </Box>
        </Box>
    );
};

export default EditCampaignDecisionBoard;
